<template>
  <div class="card form-sign-in">
    <div class="card-header">{{t('Cookie info')}}</div>
    <div class="card-body text-center">
      <span class="d-block mt-2">{{t('_CookiePolicyText')}}</span>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'CookiePolicy'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/public/CookiePolicy.vue